import SummaryTable from './summaryTable';

export default SummaryTable;
